import { isNil } from 'ramda';
import { useState, useEffect } from 'react';

import { fetchImage } from './helpers/fetchImage';

type TSource = string | null;

type TUsePreloadImageArgs = {
  src?: TSource
  fallback?: TSource
}

export function usePreloadImage({ src, fallback }: TUsePreloadImageArgs) {
  const [ loaded, setLoaded ] = useState(false);
  const [ source, setSource ] = useState(src);

  useEffect(() => {
    const getImage = (async (maybeSource?: TSource) => {
      if (isNil(maybeSource)) {
        if (!isNil(fallback)) {
          getImage(fallback);
        }

        return;
      }

      try {
        await fetchImage(maybeSource);
        setSource(maybeSource);
        setLoaded(true);
      } catch (_err) {
        setLoaded(false);

        if (!isNil(fallback) && maybeSource !== fallback) {
          getImage(fallback);
        }
      }
    });

    getImage(src);
  }, [ src, fallback ]);

  return { loaded, src: source };
}
